import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-close",
  "use": "icon-close-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol viewBox=\"0 0 12 12\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-close\"><path d=\"M6 5.57138L2.75064 2.25L2.25147 2.73728L5.42505 5.98128L2.25 9.26575L2.75211 9.75L6 6.38971L9.24789 9.75L9.75 9.26575L6.57495 5.98128L9.74853 2.73728L9.24936 2.25L6 5.57138Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol